import React from 'react';
import MultipleRemoveCategories from "@/Pages/Categories/Assets/MultipleCategoriesAction/MultipleRemoveCategories";
import MultipleShowCategories from "@/Pages/Categories/Assets/MultipleCategoriesAction/MultipleShowCategories";
import MultipleHideCategories from "@/Pages/Categories/Assets/MultipleCategoriesAction/MultipleHideCategories";

const MultipleCategoriesAction = ({checked}) => {
  return (
    <div className='flex'>
      <MultipleRemoveCategories checked={checked}/>
      <MultipleShowCategories checked={checked}/>
      <MultipleHideCategories checked={checked}/>
    </div>
  );
};

export default MultipleCategoriesAction;
